import { render } from "./App.vue?vue&type=template&id=750806ac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=750806ac&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__